import PropTypes from "prop-types";
import RelatedItem from "../RelatedItem/component";

/**
 * @param {Object} props The component props
 * @returns {React.Component} Returns the RelatedStory component
 */
export function RelatedStory(props) {
    const relatedMarkup = props.links.map((item) => {
        // If url is https://www.cbc.ca/news/canada/manitoba/volunteer-firefighters-carberry-manitoba-1.6879673
        // this split gets the id part which is "1.6879673" and will serve as an appropriate key for the list
        const sourceId = item.url.slice(item.url.lastIndexOf("-") + 1);
        return <RelatedItem key={sourceId} {...item} />;
    });

    return relatedMarkup;
}

RelatedStory.propTypes = {
    links: PropTypes.array.isRequired,
};

export default RelatedStory;
